import { Divider, Grid, useMediaQuery, useTheme } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import errorPage from '../../assets/images/errorPage.jpg';
import { StyledDescription } from '../../components/StyledDescription';
import { StyledTitle } from '../../components/StyledTitle';
import { useLoaderContext } from '../../contexts/LoaderContext';

export const ExpiredPromoPage: React.FC = () => {

    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up(970));
    const setLoader = useLoaderContext();

    React.useEffect(() => {
        setLoader(false);
    }, []);

    return (

        <Grid height="100%" container>{matches && (
            <Grid sm={5} sx={{ backgroundColor: '#E5EAF0', display: 'flex', alignItems: 'center', justifyContent: 'center' }} item>
                <img src={errorPage} width="300" alt='genericPage' />
            </Grid>
        )}
            <Grid
                sm={matches ? 7 : 12}
                sx={{
                    background: "#fff"
                }}
                item
            >
                <Box
                    display="flex"
                    justifyContent="center"
                    flexDirection="column"
                    gap={2}
                    overflow="auto"
                    height="100%"
                >
                    <StyledTitle>
                        ATTENZIONE!
                    </StyledTitle>
                    <Divider orientation="horizontal" />
                    <StyledDescription>
                        L&#39;offerta esclusiva non &egrave; pi&ugrave; valida.
                        <br />
                        <br />
                        Qualora fossi ancora interessato ad accedere al modulo software "Concordato Preventivo Biennale", puoi contattare il tuo riferimento TeamSystem
                        <br />
                        <br />
                        Grazie
                    </StyledDescription>
                </Box>
            </Grid>
        </Grid>
    );
};
